/** 2.7.000: compact audience navigation and an explicit, keyboard-operable discovery menu. */
import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Menu,
  X,
  ChevronDown,
  ArrowUpRight,
  Gamepad2,
  Play,
  Music2,
  Flame,
  Gift,
} from "lucide-react";
const audienceLinks = [
  ["/buyers", "Buyers"],
  ["/sellers", "Sellers"],
  ["/drivers", "Drivers"],
  ["/pickers", "Pickers"],
];
const exploreLinks = [
  ["/play", "KwK Play", Gamepad2],
  ["/tube", "KwK Tube", Play],
  ["/tunes", "KwK Tunes", Music2],
  ["/rewards", "Points & Rewards", Gift],
  ["/propane-exchange", "Propane Exchange", Flame],
];
export default function Navbar() {
  const [open, setOpen] = useState(false),
    [explore, setExplore] = useState(false);
  const location = useLocation(),
    nav = useRef(null);
  useEffect(() => {
    setOpen(false);
    setExplore(false);
  }, [location.pathname, location.hash]);
  useEffect(() => {
    const close = (e) => {
      if (e.key === "Escape") {
        if (open) {
          setOpen(false);
          document.getElementById("site-menu-toggle")?.focus();
        }
        if (explore) {
          setExplore(false);
          document.getElementById("site-explore-toggle")?.focus();
        }
      }
    };
    const outside = (e) => {
      if (!nav.current?.contains(e.target)) setExplore(false);
    };
    document.addEventListener("keydown", close);
    document.addEventListener("pointerdown", outside);
    return () => {
      document.removeEventListener("keydown", close);
      document.removeEventListener("pointerdown", outside);
    };
  }, [open, explore]);
  return (
    <nav ref={nav} className="cw-nav" aria-label="Main navigation">
      <div className="cw-nav-inner">
        <Link to="/" className="cw-brand" aria-label="KwK home">
          <img src="/kwk-logo.png" alt="KwK Net" width="70" height="44" />
          <span>life, connected.</span>
        </Link>
        <div className="cw-desktop-links">
          {audienceLinks.map(([to, label]) => (
            <Link
              key={to}
              to={to}
              aria-current={location.pathname === to ? "page" : undefined}
            >
              {label}
            </Link>
          ))}
          <div className="cw-explore">
            <button
              id="site-explore-toggle"
              aria-expanded={explore}
              aria-controls="site-explore-menu"
              onClick={() => setExplore(!explore)}
            >
              Explore KwK <ChevronDown size={15} />
            </button>
            {explore && (
              <div id="site-explore-menu" className="cw-explore-menu">
                {exploreLinks.map(([to, label, Icon]) => (
                  <Link key={to} to={to}>
                    <Icon size={19} />
                    {label}
                    <ArrowUpRight size={15} />
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
        <Link className="cw-nav-join" to="/#join">
          Find your place <ArrowUpRight size={16} />
        </Link>
        <button
          id="site-menu-toggle"
          className="cw-nav-toggle"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="site-mobile-menu"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div id="site-mobile-menu" className="cw-mobile-menu">
          {audienceLinks.map(([to, label]) => (
            <Link key={to} to={to}>
              {label}
              <ArrowUpRight size={18} />
            </Link>
          ))}
          <span>MORE TO DISCOVER</span>
          {exploreLinks.map(([to, label, Icon]) => (
            <Link key={to} to={to}>
              <Icon size={18} />
              {label}
            </Link>
          ))}
          <Link to="/#join">
            Connect with KwK <ArrowUpRight size={18} />
          </Link>
        </div>
      )}
    </nav>
  );
}
